<script setup lang="ts">
import {ModelList} from '@jantm/model-core'
import Dashboard from "@/components/WiserDashboardComponent.vue";
import {ref} from "vue";
import type {OfferFilter} from "@/types/Wiser/offer.ts";
import OfferFilterForm from "@/views/Wiser/OfferFilterForm.vue";
const modelFilter = ref<OfferFilter>({page: '1', perPage: '25'});
</script>

<template>
  <Dashboard />
  <div class="container">
    <OfferFilterForm v-model="modelFilter" />
    <ModelList class="model-list model-list-offer" model="Offer" :filter="modelFilter" />
  </div>
</template>

<style scoped></style>
